"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var overviewSlice_1 = __importDefault(require("@features/StatisticPage/state/overviewSlice"));
var rolesSlice_1 = __importDefault(require("@features/SettingsPage/state/rolesSlice"));
var mediasSlice_1 = __importDefault(require("@features/mediaGallery/state/mediasSlice"));
var moderationNoteSlice_1 = __importDefault(require("@features/ItemCommon/state/moderationNoteSlice"));
var dictionarySlice_1 = __importDefault(require("@features/Dictionaries/state/dictionarySlice"));
var queuesSlice_1 = __importDefault(require("@/react-app/features/Queues/state/queuesSlice"));
var currentTeamReducer_1 = __importDefault(require("./currentTeamReducer"));
var baseApi_1 = require("@/react-app/common/services/baseApi");
var ruleSlice_1 = __importDefault(require("@/react-app/features/Rules/state/ruleSlice"));
var rootReducer = (0, toolkit_1.combineReducers)((_a = {
        currentTeam: currentTeamReducer_1.default,
        roles: rolesSlice_1.default,
        medias: mediasSlice_1.default,
        moderationNoteReducer: moderationNoteSlice_1.default,
        dictionaryReducer: dictionarySlice_1.default,
        ruleReducer: ruleSlice_1.default,
        queues: queuesSlice_1.default,
        overview: overviewSlice_1.default
    },
    _a[baseApi_1.baseApi.reducerPath] = baseApi_1.baseApi.reducer,
    _a));
exports.default = rootReducer;
